/**
 * Google Maps helper (Jaime request 2026-09-15): build a directions/search
 * URL for a destination address, used by invite landing ("Cómo llegar") and
 * the guest share text. Pure util — no API changes.
 */
export function googleMapsSearchUrl(query: string): string {
  const q = (query || '').trim();
  if (!q) return '';
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}

/**
 * Coordinate-first destination URL (Jaime 2026-09-15 live-QA fix): a label
 * query like "Buena Vista — TH1" returns wrong places in Google Maps. When
 * the backend provides stored geolocation (units.latitude/longitude from
 * migration 93, or condominiums.latitude/longitude), query by `lat,lng`
 * instead; only fall back to the label string when no geo data exists.
 */
export function googleMapsDestinationUrl(opts: {
  latitude?: number | null;
  longitude?: number | null;
  label?: string | null;
}): string {
  const lat = Number(opts?.latitude);
  const lng = Number(opts?.longitude);
  if (Number.isFinite(lat) && Number.isFinite(lng) && !(lat === 0 && lng === 0)) {
    return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
  }
  const q = (opts?.label || '').trim();
  return q ? googleMapsSearchUrl(q) : '';
}
